module.exports = __webpack_public_path__ + "i18n/zh-CN.84c388a468732e3dc482b7e247a1fa77.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1318
// module chunks = 59